import { TOffer } from '@/models/offers';
import LegalRequestPanel from '../LegalRequestPanel';

export default function LegalTab({ offer }: { offer: TOffer }) {
  return (
    <LegalRequestPanel
      offerId={offer.id}
      offerAccepted={!!offer.accepted}
      invoiceStatus={offer.invoiceStatus}
    />
  );
}
